import React from 'react'
import { I18n } from 'react-redux-i18n'
import { FacebookLogin } from 'components/Buttons'
import flagEnvDisplay from 'constants/flagEnvDisplay'
/**
 * FacebookButton
 * @param {object} props
 * @param {String} props.id
 * @param {String} props.label
 * @param {String} props.value
 * @param {String} props.maxLength
 * @param {Function} props.onChange
 * @param {boolean} props.disabled
 * @param {String} props.description
 * @param {String} props.className
 */

const CHANNEL = {
  instagram:'instagram',
  facebook:'channel',
}

function getEditPermissions(channel) {
  if (channel.value.botToken) return 'facebook_btn_edit_permissions'
  if (channel.value.userID) return 'facebook_btn_edit_permissions'
  if (channel.value.accessToken) return 'facebook_btn_edit_permissions'

  return ''
}

const FacebookButton = (props) => {
  const { id, label, onChange, disabled, description, className, channel } = props
  const key = channel.hub
  let type = 'channel'
  if(key in CHANNEL) type = CHANNEL[key]

  return (
    <div className={`channel-field input ${className ? className : ''} facebook`}>
      {label && <label htmlFor={id}>{I18n.t(label)}</label>}
      {description && <p className='description'>{I18n.t(description)}</p>}
      <div className={`field-content`}>
        <FacebookLogin
          type={type}
          textTag={getEditPermissions(channel)}
          onCallback={(response) => {
            if (flagEnvDisplay.isDEV) console.info('FacebookButton response:', response)

            if (response.userID && !response.error) {
              onChange(
                'value',
                {
                  ...channel.value,
                  userId: response.userID,
                  userAccessToken: response.accessToken,
                  userName: response.name || ''
                },
                {
                  submit: true,
                  submitOptions: {
                    permissions: !!channel.value.botToken, // Only for facebook updates with permissions
                  }
                }
              )
            }
          }}
          disabled={disabled}
        />
      </div>
      {/* {typeChannel.map((input, index) => {
        return (
          <div key={index} className={`field-content`}>
            <Switch
              id={`${index}_${input.field}`}
              label={input.label}
              defaultChecked={channel.value[input.field] || false}
              onChange={(value) => {
                onChange(input.prop, value)
              }}
              disabled={disabled}
              {...input}
            />
          </div>
        )
      })} */}
    </div>
  )
}

export default FacebookButton
